import { Routes, Route } from "react-router-dom";
import { OSCI0401001Q } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401001Q";
import { OSCI0401002Q } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401002Q";
import { OSCI0401003Q } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401003Q";
import { OSCI0401004Q } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401004Q";
import { OSCI0401005Q } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401005Q";
import { OSCI0401006S } from "@/tz/go/egaz/osci/colt/ntfc/OSCI0401006S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const NtfcRouter = () => {
    return (
        <Routes>
            <Route path="/osci0401001q" element={<OSCI0401001Q />} />
            <Route path="/osci0401002q" element={<OSCI0401002Q />} />
            <Route path="/osci0401002q/:bllMgmtId" element={<OSCI0401002Q />} />
            <Route path="/osci0401002q/:bllMgmtId/:scrnId" element={<OSCI0401002Q />} />
            <Route path="/osci0401003q" element={<OSCI0401003Q />} />
            <Route path="/osci0401003q/:tansadNo" element={<OSCI0401003Q />} />
            <Route path="/osci0401003q/:tansadNo/:scrnId" element={<OSCI0401003Q />} />
            <Route path="/osci0401004q" element={<OSCI0401004Q />} />
            <Route path="/osci0401005q" element={<OSCI0401005Q />} />
            <Route path="/osci0401005q/:bllMgmtId" element={<OSCI0401005Q />} />
            <Route path="/osci0401005q/:bllMgmtId/:aprvYn" element={<OSCI0401005Q />} />
            <Route path="/osci0401006s/:mode" element={<OSCI0401006S />} />
            <Route path="/osci0401006s/:mode/:bllMgmtId" element={<OSCI0401006S />} />
        </Routes>
    );
};
